import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { Button, CircularProgress } from '@mui/material';
import React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DecodeFormBase64 } from '../../../helpers/tools';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import AuditoriaDetalleDataGrid from './AuditoriaDetalleDataGrid';
import { Link } from 'react-router-dom';
import ErrorDialog from '../../../components/ErrorDialog';
import Cookies from 'universal-cookie';


export default function AuditoriaDetalle() {

  const cookies = new Cookies();

  const navigate = useNavigate();
  let params = useParams();

  function createData(campo, valorAntiguo, valorNuevo) {
    return { campo, valorAntiguo, valorNuevo };
  }

  let rows = [];

  let auditoriaId = "";

  if (params != "") {
    try {
      auditoriaId = parseInt(DecodeFormBase64(params.auditoriaId), 10);
    } catch {
    }
  }

  // redirecciono a la grilla en caso de no recibir un parámetro numérico
  useEffect(() => {
    cookies.set('auditoria_filter_Activo', true);
    if (isNaN(auditoriaId)) {
      navigate('/auditoria');
    }
  }, []);

  const handleCloseDlgError = () => {
    // retorno al auditoria.
    navigate("/auditoria");
  };

  const generarColumns = () => {
    const columns = [
      { field: 'valorAntiguo', headerName: 'Valor Antiguo', minWidth: 200, flex: 0.7, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'valorNuevo', headerName: 'Valor Nuevo', minWidth: 200, flex: 0.7, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'tabla', headerName: 'Tabla', minWidth: 50, flex: 0.5, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center' },
      { field: 'idClaveSecundaria', headerName: 'Clave Secundaria', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center', align: 'center' },
      { field: 'digitoValido', headerName: 'Valido', minWidth: 80, flex: 0.4, headerClassName: 'super-app-theme--header', cellClassName: 'super-app-theme--cell', headerAlign: 'center', align: 'center' }];


    return columns;
  };


  const QDetalle = gql`
        query QDetalle($idAuditoria: Int!) {
            auditoriaDetalle(
                idAuditoria: $idAuditoria
            ) 
            {
                success,
                error,
                valorEsperado {
                    valorAntiguo
                    valorNuevo
                    digitoVerificador
                    tabla,
                    digitoValido,
                    idClaveSecundaria,
                    accion
                }
            }
        }`;

  const { loading, error, data } = useQuery(QDetalle, { fetchPolicy: 'no-cache', variables: { idAuditoria: auditoriaId } });

  if (loading) return <CircularProgress disableShrink />;
  if (error) return <ErrorDialog
    id="dlg-error-terminos"
    open={error}
    onClose={handleCloseDlgError}
    mensaje="ERRORDB" />;


  if (data) {
    if (data.auditoriaDetalle.success) {

      const columns = generarColumns();

      return (
        <>
          <div className='botonera-superior'>
            <Link to="/auditoria" style={{ textDecoration: 'none' }}>
              <Button
                endIcon={<KeyboardReturnIcon />}
                size='small'
                title="Volver a la grilla de Auditoria"
                variant='contained'>
                Volver
              </Button>
            </Link>
          </div>
          <br />
          {
            data.auditoriaDetalle.valorEsperado.map((item) => {
              rows = [];
              const tabla = item.tabla;
              const claveSecundaria = item.idClaveSecundaria;
              const digitoValido = item.digitoValido;

              if (item.accion === '1') {
                const data = JSON.parse(item.valorNuevo);
                for (let i in data) {
                  rows.push(createData(i, '', data[i]));
                }
              } else
                if (item.accion === '2') {
                  const data = JSON.parse(item.valorAntiguo);
                  for (let i in data) {
                    rows.push(createData(i, data[i], ''));
                  }
                } else {

                  const dataNuevo = item.valorNuevo !== "" ? JSON.parse(item.valorNuevo) : "";
                  const dataAntiguo = item.valorAntiguo !== "" ? JSON.parse(item.valorAntiguo) : "";
                  let lista = dataNuevo !== "" ? dataNuevo : dataAntiguo;

                  for (let i in lista) {
                    rows.push(createData(i, dataAntiguo[i], dataNuevo[i]));
                  }
                }

              return <AuditoriaDetalleDataGrid rows={rows} tabla={tabla} claveSecundaria={claveSecundaria} digitoValido={digitoValido} />;
            })
          }

        </>);


    } else {

      return (
        <>
          <ErrorDialog
            id="dlg-error-terminos"
            open={data.auditoriaDetalle.error != null}
            onClose={handleCloseDlgError}
            mensaje={data.auditoriaDetalle.error} />

        </>);

    }


  }
};